import React from "react";
//#region types
import { WintSuperkollAPIModel as APIModels } from "wint-api-client/dist/types";
import { ReceiptStatusTagsProps } from "models/propTypes/receiptPropTypes";
//#endregion
//#region components
import { Tags } from "components/common";
import { useReceiptService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ReceiptStatusTags: React.FC<ReceiptStatusTagsProps> = (props) => {
  const receiptService = useReceiptService();
  const getLabelClass = (status: APIModels.ReceiptStateApiModel) => {
    switch (status) {
      case APIModels.ReceiptStateApiModel.Received:
      case APIModels.ReceiptStateApiModel.Investigation:
        return cssExports.blueTag;

      case APIModels.ReceiptStateApiModel.Booked:
      case APIModels.ReceiptStateApiModel.PayoutRescheduled:
      case APIModels.ReceiptStateApiModel.PaymentSign:
      case APIModels.ReceiptStateApiModel.Stopped:
        return cssExports.greenTag;

      case APIModels.ReceiptStateApiModel.WaitingAcceptance:
        return cssExports.yellowTag;

      case APIModels.ReceiptStateApiModel.SentBackToCustomer:
      case APIModels.ReceiptStateApiModel.SentBackFromReceiptAdmin:
        return cssExports.redTag;

      case APIModels.ReceiptStateApiModel.Canceled:
      case APIModels.ReceiptStateApiModel.Draft:
        return cssExports.grayTag;

      default:
        return cssExports.grayTag;
    }
  };

  return (
    <Tags
      tags={[receiptService.getStateText(receiptService.apiToViewStatus(props.status))]}
      className={getLabelClass(props.status)}
    />
  );
};

export default ReceiptStatusTags;
